import React from 'react';
import { TextField, Button, Typography, CircularProgress, Snackbar } from '@material-ui/core';
import HttpModule from '../../services/http.module';

export function PollingPage(props) {

    const [isLoading, setLoading] = React.useState(false)
    const [content, setContent] = React.useState('');

    const submitData = () => {
        setLoading(true)
        HttpModule.CreatePolling(content)
        .then(r => {
            setContent('')
            alert('با موفقیت ثبت شد')
        })
        .catch(e => {
            alert('خطا در ثبت')
        })
        .finally(() => {
            setLoading(false)
        })
    }

    return <div className="row">
        <div className="col-12">
            <div className="row">
                <div className="col-lg-6 py-3">
                    <div className="row">
                        <div className="col-12">
                            <Typography variant='h4' align='center' >
                                نظر سنجی        
                            </Typography>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <Typography variant='body1' className='mx-auto w-50 p-3' align='justify' >
                            ضمن تشکر از بازدید شما، خواهشمندیم به منظور ارائه خدمات بهتر، هرگونه پیشنهاد و انتقاد سازنده خود را با ما در میان گذاشته تا با برطرف نمودن ایرادات و استفاده از پیشنهادات ارزشمند شما در جهت ارائه خدمات بهتر استفاده کنیم.
                            <br />
                            <span className='font-weight-bold '>
                                در نظر داشته باشید که نام و اطلاعات شما محفوض میباشد و به صورت محرمانه ، انتقادات و پیشنهادات شما ثبت میشود
                            </span>
                            </Typography>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 py-3">
                    
                    <div className="row">
                        <div className="col-12 text-center">
                            <TextField 
                                value={content}
                                className='w-50 rounded-pill' 
                                variant='filled' 
                                label='انتقادات و پیشنهادات شما...' 
                                multiline 
                                rows={5} 
                                onChange={e => setContent(e.target.value)}
                                rowsMax={8} 
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 py-2 text-center">
                            <Button className='w-50 shadow-none rounded-pill' onClick={submitData} disabled={isLoading} variant={'contained'} color='secondary'>
                                {isLoading ? <CircularProgress size={'1.5rem'} /> : 
                                <>
                                ثبت
                                </>
                                }
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default PollingPage